export default __webpack_public_path__ + "static/media/1.8b477d18.jpg";